import {FormSubmission} from 'forms/form-instance/Constants';
import * as net from 'util/Net';

export function submitFormSubmission(
  formSubmission: FormSubmission,
  formDefinitionVersionId: string
): Promise<{id: string}> {
  const data = {
    formDefinitionVersionId,
    fieldValues: formSubmission.fieldValues,
  };
  return net.postJSONPromise({
    url: '/1/api/forms/form-submission',
    data,
  });
}
